import type { RxJsonSchema } from 'rxdb';
import type { ConditionRating } from './conditionRating.types';

export const conditionRatingSchema: RxJsonSchema<ConditionRating> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
